import React from "react"
import { useSearchParams, useNavigate } from "react-router-dom"
import { Emit_main } from "../navigation"
import * as C from "../controls"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons"

const Integration_error_content = () => {
    const [searchParams] = useSearchParams()
    const navigate = useNavigate()
    const error = searchParams.get('error') || 'An error occurred during integration'
    const detail = searchParams.get('detail')

    return (
        <div className="tw-max-w-2xl tw-mx-auto tw-mt-8">
            <C.Eres_card>
                <div className="tw-p-8 tw-text-center">
                    <FontAwesomeIcon
                        icon={faExclamationTriangle}
                        className="tw-text-6xl tw-text-red-600 tw-mb-4"
                    />
                    <h1 className="tw-text-2xl tw-font-bold tw-mb-4 tw-text-red-900">
                        Integration Failed
                    </h1>
                    <p className="tw-text-lg tw-text-gray-700 tw-mb-2">{error}</p>
                    {detail && detail !== 'None' && (
                        <p className="tw-text-sm tw-text-gray-600 tw-mb-6">{detail}</p>
                    )}
                    <div className="tw-flex tw-gap-4 tw-justify-center tw-mt-6">
                        <C.Eres_button onClick={() => navigate('/connected-networks')}>
                            Go to Networks
                        </C.Eres_button>
                        <C.Eres_button onClick={() => navigate('/onboarding')}>
                            Back to Onboarding
                        </C.Eres_button>
                    </div>
                </div>
            </C.Eres_card>
        </div>
    )
}

export default function Integration_error() {
    return (
        <Emit_main page_id="PAGE-connected-networks">
            <Integration_error_content />
        </Emit_main>
    )
}
